// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__t3zj0","stats":"style_stats__TfecU"};